import ErroQuestionarioQuestao from './ErroQuestionarioQuestao';

/**
 * Objeto para armazenar as mensagens de erro da seção
 */
class ErroQuestionarioSecao {

    /**
     * Cria uma nova instância da lista de erros da seção
     * Caso os parâmetros não sejam informados, cria com valores padrão
     * 
     * @param {Boolean} valido Indica se o objeto é valido ou não
     * @param {String} erroSecao Mensagem de erro geral do objeto
     * @param {String} titulo Mensagem de erro para o título
     * @param {String} erroQuestoes Mensagem de erro relativo a lista de questões
     * @param {Array<ErroQuestionarioQuestao>} questoes Lista com os erros das questões
     */
    constructor(valido, erroSecao, titulo, erroQuestoes, questoes) {
        /** @member {Boolean} valido Indica se o objeto é valido ou não */
        this.valido = valido ?? true;
        /** @member {String} erroSecao Mensagem de erro geral do objeto */
        this.erroSecao = erroSecao ?? '';
        /** @member {String} titulo Mensagem de erro para o título */
        this.titulo = titulo ?? '';
        /** @member {String} erroQuestoes Mensagem de erro relativo a lista de questões */
        this.erroQuestoes = erroQuestoes ?? '';
        /** @member {Array<ErroQuestionarioQuestao>} questoes Lista com os erros das questões */
        this.questoes = questoes ?? [];
    }

    /**
     * Verifica se dois objetos possuem os mesmos valores
     * @param {ErroQuestionarioSecao} obj1 Primeiro objeto a ser comparado
     * @param {ErroQuestionarioSecao} obj2 Segundo objeto a ser comparado
     * @returns {Boolean} Retorna verdadeiro se os dois objetos forem iguais
     */
    static compare(obj1, obj2) {
        //Se os dois possuírem o mesmo endereço de memória
        if (obj1 === obj2)
            return true;
        //Se um dos dois for nulo
        if (!obj1 || !obj2)
            return false;
        //Compara as propriedades
        let result = obj1.valido === obj2.valido
                  && obj1.erroSecao === obj2.erroSecao
                  && obj1.titulo === obj2.titulo
                  && obj1.erroQuestoes === obj2.erroQuestoes;

        //Caso as propriedades sejam iguais, verifica as listas
        if (result) {
            return ErroQuestionarioSecao.compareQuestoes(obj1.questoes, obj2.questoes);
        } else {
            return false;
        }
    }

    /**
     * Compara a lista de erros das questões da seção
     * @param {Array<ErroQuestionarioQuestao>} list1 Lista de erros das questões do primeiro objeto
     * @param {Array<ErroQuestionarioQuestao>} list2 Lista de erros das questões do segundo objeto
     * @returns {Boolean} Retorna verdadeiro se os itens das duas listas são iguais
     */
    static compareQuestoes(list1, list2) {
        //Se as duas listas possuírem o mesmo endereço de memória
        if (list1 === list2)
            return true;
        //Se uma das duas for nula
        if (!list1 || !list2)
            return false;
        //Se os tamanhos forem diferentes
        if (list1.length !== list2.length)
            return false;
        //Verifica se existe algum item que seja diferente entre as listas
        for (let i = 0; i < list1.length; i++) {
            if (!ErroQuestionarioQuestao.compare(list1[i], list2[i]))
                return false;
        }
        return true;
    }
}

export default ErroQuestionarioSecao;